import { IKey } from "dto/IKey";
import { IDecryptedKeys } from "./decryptKeys";
import { readFileFromBase64 } from "./readFileFromBase64";
import { getActiveProfilePrivateKeys } from "./activeProfileKeys";
import * as openpgp from "openpgp";

export const decryptPrivateKey = async (
  myKeys: IDecryptedKeys,
  key: IKey,
  emptyPassphrase?: boolean,
  parentKey?: IKey | null | undefined,
) => {
  if (!key) {
    throw new Error("Key not found");
  }

  if (key.ParentKeyId && !parentKey) {
    throw new Error("Parent key not found");
  }

  if (parentKey) {
    console.log(
      `Dekodowanie klucza ${key?.Id} kluczem rodzica ${parentKey?.Id}`,
    );
  } else {
    console.log(
      `Dekodowanie klucza ${key?.Id} kluczem użytkownika`,
      key.ParentKeyId,
    );
  }

  const privateKeyData = await readFileFromBase64(
    key.PrivateKey,
    "application/other",
  );
  const msg = await openpgp.message.read(new Uint8Array(privateKeyData));

  // Klucz(e), którymi odszyfrowujemy klucz prywatny `key`.
  let privateKeys: openpgp.key.Key[] = [];

  if (parentKey) {
    const decryptedParentKey = await decryptPrivateKey(myKeys!, parentKey);
    const text = await openpgp.key.read(decryptedParentKey.data);
    privateKeys = [text.keys[0]];
  } else {
    // Klucz najwyższego rzędu (bez rodzica) jest od czasu profili szyfrowany kluczem
    // AKTYWNEGO PROFILU, a nie kluczem intermediate. Podajemy więc klucze profilu
    // (pierwotny + dodatkowe ze scaleń) — openpgp dobierze właściwy po ID z szyfrogramu —
    // a klucz intermediate zostawiamy jako fallback (profil bazowy / konta sprzed profili /
    // gdy mirror profilu nie jest jeszcze wypełniony).
    privateKeys = [...getActiveProfilePrivateKeys()];
    try {
      const intermediate = await openpgp.key.readArmored(
        atob(myKeys!.intermidatePrivateKey!.data),
      );
      privateKeys.push(intermediate.keys[0]);
    } catch (ex) {
      console.error(ex);
    }
  }

  if (emptyPassphrase === true) {
    for (const pk of privateKeys) {
      try {
        pk.decrypt("");
      } catch {
        // już odblokowany / bez hasła — ignorujemy
      }
    }
  }

  const options: openpgp.DecryptOptions = {
    message: msg,
    privateKeys: privateKeys,
    format: "binary",
  };

  return await openpgp.decrypt(options);
};
